import { EditorValidator, EditorArgs } from "angular-slickgrid";

export const customNumberValidator: EditorValidator = (value: any, args: EditorArgs) => {
  // you can get the Editor Args which can be helpful, e.g. we can get the Translate Service from it
  const grid = args && args.grid;
  let decimalParts;

  if (value === '') {
    return { valid: false, msg: 'This field required' };
  } else if (/^[0-9]*[.][0-9]+$/.test(value)) {
    decimalParts = value.split('.');
    args.item['SPLIT_QTY'] = decimalParts[0];
    return {
      valid: false, msg: 'Field should contain only integers'
    };
    // OR use the Translate Service with your custom message
    // return { valid: false, msg: i18n.tr('YOUR_ERROR', { x: value }) };
  } else {
    return { valid: true, msg: '' };
  }
};

export const customNumberOnlyValidator: EditorValidator = (value: any, args: EditorArgs) => {
  // you can get the Editor Args which can be helpful, e.g. we can get the Translate Service from it
  const grid = args && args.grid;
  let decimalParts;

  if (value === '') {
    return { valid: false, msg: 'This field required' };
  } else if (/^\d+$/.test(value)) {

    return {
      valid: true, msg: ''
    };
    // OR use the Translate Service with your custom message
    // return { valid: false, msg: i18n.tr('YOUR_ERROR', { x: value }) };
  } else {
    args.item[args.column.field] = value.replace(/[^0-9 ]/g, '');
    return { valid: false, msg: 'Field should contain only integers' };
  }
};

export const customPhoneNumberValidator: EditorValidator = (value: any, args: EditorArgs) => {
  const lengthValidation = (value.length >= 3 && value.length < 14);
  if (value === '') {
    return { valid: true, msg: 'This field required' };
  } else if (/^(\+)?(\d)?\d+$/.test(value) && lengthValidation) {
    return {
      valid: true, msg: ''
    };
  } else {
    args.item[args.column.field] = '';
    return { valid: false, msg: 'Field should contain only integers' };
  }
};

export const customEmailValidator: EditorValidator = (value: any, args: EditorArgs) => {
  if (value === '') {
    return { valid: true, msg: '' };
  } else if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(value)) {
    return {
      valid: true, msg: ''
    };
  } else {
    return { valid: false, msg: 'Please Enter a valid mail' };
  }
};
